(function ($) {
	'use strict';

	$(function () {
		[...document.querySelectorAll('.js-paginated-stories')].forEach((stories) => {
			let currentPanel = 1;
			const panels = [...stories.querySelectorAll('.js-paginated-stories-panel')];
			const panelCount = panels.length;
			const paginationNumbers = [...stories.querySelectorAll('.js-paginated-stories-number')];
			const paginationPrev = stories.querySelector('.js-paginated-stories-prev');
			const paginationNext = stories.querySelector('.js-paginated-stories-next');

			function updatePanel(activePanel) {
				panels.forEach((panel) => {
					panel.classList.add('paginated-stories__panel--hidden');
					panel.setAttribute('aria-hidden', true);
				});

				activePanel.classList.remove('paginated-stories__panel--hidden');
				activePanel.removeAttribute('aria-hidden');

				// Refocus keyboard nav.
				activePanel.querySelector('a').focus();
			}

			function updatePaginationNumber(activeNumber) {
				paginationNumbers.forEach((number) => {
					number.classList.remove('current', 'disabled');
					number.removeAttribute('disabled');
				});

				activeNumber.classList.add('current', 'disabled');
				activeNumber.disabled = true;
			}

			function toggleDisabledNav(activePanel) {
				if ( activePanel !== 1 ) {
					paginationPrev.classList.remove('disabled');
				} else {
					paginationPrev.classList.add('disabled');
				}

				if ( activePanel !== panelCount ) {
					paginationNext.classList.remove('disabled');
					paginationNext.removeAttribute('disabled');
				} else {
					paginationNext.classList.add('disabled');
					paginationNext.disabled = true;
				}
			}

			paginationNumbers.forEach((number) => {
				number.addEventListener('click', (event) => {
					event.preventDefault();

					const targetPanel = document.querySelector(number.dataset.panel);

					updatePanel(targetPanel);
					updatePaginationNumber(number);

					currentPanel = parseInt(number.dataset.panelNo);

					toggleDisabledNav(currentPanel);
				});
			});

			paginationPrev.addEventListener('click', (event) => {
				event.preventDefault();

				if ( currentPanel !== 1 && ! paginationPrev.classList.contains('disabled') ) {
					currentPanel = currentPanel - 1;

					updatePanel(panels[currentPanel - 1]);
					updatePaginationNumber(paginationNumbers[currentPanel - 1]);
					toggleDisabledNav(currentPanel);
				}
			});

			paginationNext.addEventListener('click', (event) => {
				event.preventDefault();

				if ( currentPanel !== panelCount && ! paginationNext.classList.contains('disabled') ) {
					currentPanel = currentPanel + 1;

					updatePanel(panels[currentPanel - 1]);
					updatePaginationNumber(paginationNumbers[currentPanel - 1]);
					toggleDisabledNav(currentPanel);
				}
			});
		});
	});
})(jQuery, document, window);
